import { Icon } from '../../../graphql/__generated/graphql';
import { VirtualTourIconId } from '@ael/virtual-tour-icon-bundle';

type IconData = {
  kitIconId: VirtualTourIconId;
} & Omit<Icon, '__typename' | 'identifier'>;

/**
 * Represents an icon from the hand-picked collection of icons.
 */
export type KitIcon = {
  kitIconId: VirtualTourIconId;
  scale: number;
};

export const KitIconHelper = {
  create: create,
  createDefault: (params?: Partial<IconData>): KitIcon => create({ kitIconId: 'up', scale: 1, ...params }),
  changeIconId: (icon: KitIcon, iconId: VirtualTourIconId): KitIcon => ({
    ...icon,
    kitIconId: iconId,
  }),
};

function create(params: IconData): KitIcon {
  return {
    ...params,
  };
}
